import { storeToRefs } from "pinia";
import { useBannerStore } from "@store/useBannerStore";
import { useDashboardStore } from "@store/useDashboardStore";

/**
 * Reads dashboard projections without starting a fetch or polling timer.
 * Call from child views; the page root owns loading through useDashboardSession.
 */
export function useDashboardView() {
  const dashboardStore = useDashboardStore();
  const bannerStore = useBannerStore();
  const { report, regionAliases, regionNames, incidents, eventsBlockReport } = storeToRefs(dashboardStore);
  const { banners, emergencyReport, maintenanceReport } = storeToRefs(bannerStore);

  return {
    report,
    incidents,
    banners,
    regionAliases,
    regionNames,
    eventsBlockReport,
    emergencyReport,
    maintenanceReport,
  };
}